import { useContext, useRef } from "react";
import { useForm } from "react-hook-form";
import CustomModal from "../components/modal";
import CustomTextInput from "../components/textInput";
import { UserDataContext } from "../context/UserContextProvider";
import { ToastDataContext } from "../context/ToastContextProvider";
import { useNavigate } from "react-router-dom";
import { hrGuestCustomerCreateEndpoint } from "../hr_endpoints";

export default function HRDashboardListSlotListGuestAddModal({ open, setOpen, onGuestConclusion, activeSlotId }) {
    const formRef = useRef(null);
    const { register, handleSubmit } = useForm();

    const userContext = useContext(UserDataContext)
    const toastContext = useContext(ToastDataContext)
    const navigate = useNavigate()
    const onSubmit = async (data) => {
        const response = await fetch(hrGuestCustomerCreateEndpoint(activeSlotId), {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${userContext.user?.token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                first_name: data.first_name,
                last_name: data.last_name,
                phone: data.phone
            })
        })

        if (response.status === 401) {
            userContext.setUserData({})
            navigate('/login')
            toastContext.error("Sesiunea a expirat");
        }

        if (!response.ok) {
            toastContext.error(await response.text())
        } else {
            toastContext.success("Clientul a fost adaugat si alocat cu succes")
            setOpen(false)
            onGuestConclusion()
        }
    }

    const onCancel = () => {
        setOpen(false);
        onGuestConclusion();
    }

    return (
        <CustomModal open={open} setOpen={setOpen} title="Asigneaza client nou" cancelButton={"Anulează"} confirmButton={"Asigneaza"} onConfirm={() => {
            formRef.current?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }} onCancel={onCancel} noOutsideClick={true} withIcon={false}>
            <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                <div className="flex flex-row gap-2 flex-wrap">
                    <div>
                        <label htmlFor="reason" className="block font-subtitle text-neutral-1100 mb-2">Nume client</label>
                        <CustomTextInput register={register('first_name')} placeholder={"Nume client"} className="w-full max-w-[25rem]" />
                    </div>
                    <div>
                        <label htmlFor="reason" className="block font-subtitle text-neutral-1100 mb-2">Prenume client</label>
                        <CustomTextInput register={register('last_name')} placeholder={"Prenume client"} className="w-full max-w-[25rem]" />
                    </div>
                    <div>
                        <label htmlFor="reason" className="block font-subtitle text-neutral-1100 mb-2">Telefon client</label>
                        <CustomTextInput register={register('phone')} placeholder={"Telefon client"} className="w-full max-w-[25rem]" />
                    </div>
                </div>
            </form>
        </CustomModal>
    )
}